import React from 'react';
import PropTypes from 'prop-types';
import useEnhancedEffect from '../private/hooks/useEnhancedEffect';

/**
 * NoSsr removes components from Server Side Rendering (SSR).
 *
 * Usage:
 *
 * ```jsx
 * import { NoSsr } from '@one-thd/sui-atomic-components';
 * ```
 */
const NoSsr = (props) => {
  const { children, defer = false, fallback = null } = props;
  const [mounted, setMounted] = React.useState(false);

  useEnhancedEffect(() => {
    if (!defer) {
      setMounted(true);
    }
  }, [defer]);

  React.useEffect(() => {
    if (defer) {
      setMounted(true);
    }
  }, [defer]);

  return <>{mounted ? children : fallback}</>;
};

NoSsr.displayName = 'NoSsr';

NoSsr.propTypes = {
  /**
   * You can wrap a node.
   */
  children: PropTypes.node,
  /**
   * If `true`, will further delay rendering on the client.
   * @default false
   */
  defer: PropTypes.bool,
  /**
   * The fallback content to display.
   * @default null
   */
  fallback: PropTypes.node,
};

export { NoSsr };